enum Mutations {
  SET_PAGE = 'setPage'
}

export default Mutations;
